// extracted by mini-css-extract-plugin
module.exports = {"boxContain":"styles_boxContain__1vyhM","colorContainer":"styles_colorContainer__37I8X"};